import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Sparkles, ChevronRight } from 'lucide-react';
import Layout from '@/components/Layout';
import { isMember } from '@/lib/entitlements';

// Full-page "Taster" lock — shown when a free grower opens a Premium-only tool.
// A frosted, premium preview with a single Unlock → /paywall action. The real
// page never mounts for non-members, so no gated data is fetched.
export function PremiumLockScreen({ user, title = 'A Premium feature', blurb = 'Unlock this with Homegrown Premium.' }) {
  const navigate = useNavigate();
  return (
    <Layout user={user}>
      <div className="flex items-center justify-center" style={{ minHeight: '70vh' }}>
        <div data-testid="premium-lock-screen"
          className="relative w-full max-w-xl rounded-[28px] overflow-hidden text-center"
          style={{ background: '#0F2D1F', boxShadow: '0 30px 70px -24px rgba(15,45,31,0.6)', padding: '56px 32px' }}>
          <div className="absolute inset-0 pointer-events-none" aria-hidden="true"
            style={{ background: 'radial-gradient(circle at 50% 0%, rgba(180,211,48,0.18), transparent 60%)' }} />
          <div className="relative flex flex-col items-center">
            <div className="flex items-center justify-center rounded-full mb-5"
              style={{ width: 64, height: 64, background: '#15351F', border: '1px solid rgba(231,182,75,0.6)', boxShadow: '0 0 28px -2px rgba(231,182,75,0.8)' }}>
              <Lock className="w-6 h-6" style={{ color: '#E7B64B' }} />
            </div>
            <h1 className="text-3xl font-bold text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>{title}</h1>
            <p className="mt-3 max-w-md mx-auto" style={{ color: 'rgba(250,246,236,0.85)' }}>{blurb}</p>
            <button onClick={() => navigate('/paywall')} data-testid="premium-upgrade-button"
              className="hg-press mt-7 inline-flex items-center gap-2 rounded-full px-6 py-3 font-bold transition-all"
              style={{ background: '#B4D330', color: '#0F2D1F' }}>
              <Sparkles className="w-4 h-4" />
              Start your 14-day free trial
              <ChevronRight className="w-4 h-4" />
            </button>
            <p className="mt-4 text-xs" style={{ color: 'rgba(250,246,236,0.6)' }}>Free Taster: browse the Handbook, Vege Exchange, Community & your local weather.</p>
          </div>
        </div>
      </div>
    </Layout>
  );
}

// HOC: gate a page component behind Premium. `user` is injected by ProtectedRoute.
export function withPremiumGate(Wrapped, meta = {}) {
  return function PremiumGated(props) {
    if (isMember(props.user)) return <Wrapped {...props} />;
    return <PremiumLockScreen user={props.user} title={meta.title} blurb={meta.blurb} />;
  };
}
